import React, { useEffect, useState, useRef, createElement } from 'react';
import { BookOpen, CheckCircle2, Download, ShieldCheck, Lock, FileText, User, Mail, Phone, Globe, X, ArrowRight, Sparkles, Star, Clock, TrendingUp, Home, DollarSign, Zap, Target, Briefcase, XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { DownloadNotification } from '../components/DownloadNotification';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function CarSalesmanPage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'CarSalesman-LandingView');
    // Secondary pixel — fires PageView + ViewContent scoped to this pixel only
    window.fbq('init', '4285913388317138');
    window.fbq('trackSingle', '4285913388317138', 'PageView');
    window.fbq('trackSingle', '4285913388317138', 'ViewContent', {
      content_name: 'Car Salesman Landing Page',
      source: '/car-salesman'
    });
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const finalName = nameRef.current?.value?.trim() || name.trim();
    const finalEmail = emailRef.current?.value?.trim() || email.trim();
    const finalPhone = phoneRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!finalPhone || finalPhone.length < 7) {
      alert('Por favor ingresa tu teléfono');
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Car Salesman Guide'
        });
      }
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: finalName,
          email: finalEmail,
          phone: `${areaCode}${finalPhone}`,
          first_name: finalName.split(' ')[0],
          last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
          full_name: finalName,
          fullPhone: `${areaCode}${finalPhone}`,
          areaCode: areaCode,
          source: '/car-salesman',
          page_path: '/car-salesman',
          tag: 'car-salesman-guide',
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          action_source: 'website'
        })
      });
      navigate('/escapa-del-dealership-gracias');
    } catch (err) {
      console.error('Submit error:', err);
      navigate('/escapa-del-dealership-gracias');
    } finally {
      setIsSubmitting(false);
    }
  };
  const benefits = [{
    icon: Zap,
    text: 'Sin saber programar'
  }, {
    icon: DollarSign,
    text: 'Sin capital inicial'
  }, {
    icon: Home,
    text: 'Sin showroom, sin gerente, sin cuotas'
  }, {
    icon: Target,
    text: 'Aprovecha 100% lo que YA SABES hacer: cerrar ventas'
  }];
  const insideGuide = [{
    number: '01',
    title: 'Por qué el dealership te tiene atrapado',
    desc: 'La verdad sobre los "buenos meses" y por qué tu techo de ingresos no es culpa tuya.'
  }, {
    number: '02',
    title: 'El modelo de negocio que no requiere inventario',
    desc: 'Cómo monetizar tus habilidades de cierre sin un solo carro físico.'
  }, {
    number: '03',
    title: 'Los 3 nichos rentables para vendedores hispanos en USA',
    desc: 'Dónde está la oportunidad real — y por qué tu acento es una ventaja, no una limitación.'
  }, {
    number: '04',
    title: 'Cómo replicar tus números desde casa',
    desc: 'El plan de 30 días para hacer la transición sin renunciar el primer mes.'
  }];
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-750">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-751">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-752" />
      </noscript>

      {/* Ambient background glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-753" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-754" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-755" />

      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-756" />

      {/* ============ FLOATING HEADER ============ */}
      <header className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6 pointer-events-none" data-id="element-757">
        <div className="max-w-5xl mx-auto pointer-events-auto" data-id="element-758">
          <div className="relative bg-[#0f1b35]/80 backdrop-blur-xl border border-amber-500/25 rounded-full shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_30px_-10px_rgba(245,158,11,0.3)]" data-id="element-759">
            <div className="flex items-center justify-between gap-3 pl-3 pr-2 md:pl-5 md:pr-2.5 py-2 md:py-2.5" data-id="element-760">
              {/* LEFT — Brand */}
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-761">
                <div className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-amber-500/15 border border-amber-500/40 flex-shrink-0" data-id="element-762">
                  <BookOpen className="w-4 h-4 md:w-4.5 md:h-4.5 text-amber-400" data-id="element-763" />
                </div>
                <div className="flex flex-col leading-none min-w-0" data-id="element-764">
                  <span className="text-amber-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.18em] leading-none" data-id="element-765">
                    Guía Gratuita
                  </span>
                  <span className="text-white text-xs md:text-sm font-black tracking-tight mt-1 truncate" data-id="element-766">
                    Escapa del Dealership
                  </span>
                </div>
              </div>

              {/* CENTER — Meta (desktop only) */}
              <div className="hidden lg:flex items-center gap-2 px-3" data-id="element-767">
                <Briefcase className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-768" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-769">
                  Vendedores Hispanos
                </span>
                <span className="inline-block w-px h-3.5 bg-amber-500/25" data-id="element-770" />
                <Globe className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-771" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-772">
                  En USA
                </span>
              </div>

              {/* RIGHT — CTA */}
              <button type="button" onClick={() => setShowModal(true)} className="group flex items-center gap-1.5 md:gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[10px] md:text-xs uppercase tracking-tight rounded-full px-3.5 md:px-5 py-2 md:py-2.5 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.6)] hover:shadow-[0_8px_25px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 flex-shrink-0 whitespace-nowrap" data-id="element-773">
                <Download className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-774" />
                <span className="hidden sm:inline" data-id="element-775">Descargar Gratis</span>
                <span className="sm:hidden" data-id="element-776">Descargar</span>
                <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4 transition-transform group-hover:translate-x-0.5" data-id="element-777" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-6xl mx-auto px-4 pt-20 md:pt-28 pb-12" data-id="element-778">
        {/* ============ HERO ============ */}
        <section className="mb-16 md:mb-24 text-center" data-id="element-779">
          {/* Headline */}
          <h1 className="text-[2rem] md:text-5xl lg:text-[3.75rem] font-black leading-[1.05] tracking-tight mb-5 md:mb-6 max-w-4xl mx-auto" data-id="element-780">
            Escapa del Dealership y{' '}
            <span className="relative inline-block" data-id="element-781">
              <span className="relative z-10 text-amber-400" data-id="element-782">
                Genera $10K–$20K
              </span>
              <span className="absolute bottom-1 left-0 w-full h-2.5 bg-amber-400/15 -z-0 rounded-sm" data-id="element-783" />
            </span>{' '}
            al Mes Desde Casa
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-784">
            El modelo de negocio que cientos de vendedores hispanos en USA están
            usando para construir{' '}
            <span className="text-white font-semibold" data-id="element-785">
              libertad financiera
            </span>{' '}
            — aplicando exactamente las habilidades que{' '}
            <span className="text-white font-semibold" data-id="element-786">ya tienes</span>.
          </p>

          {/* Book image — directly under headline */}
          <div className="relative flex flex-col items-center mb-10 md:mb-14" data-id="element-787">
            <div className="relative w-full max-w-2xl lg:max-w-3xl" data-id="element-788">
              {/* Floating accent badges — desktop only (overlap intentional on lg screens) */}
              <div className="hidden md:flex absolute top-4 left-0 lg:-left-6 z-20 bg-[#0f1b35] border border-amber-500/30 rounded-2xl px-4 py-3 shadow-2xl" data-id="element-789">
                <div className="flex items-center gap-2.5" data-id="element-790">
                  <div className="w-9 h-9 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center" data-id="element-791">
                    <TrendingUp className="w-4 h-4 text-emerald-400" data-id="element-792" />
                  </div>
                  <div className="text-left" data-id="element-793">
                    <div className="text-[10px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-794">
                      Ingreso meta
                    </div>
                    <div className="text-sm font-black text-white leading-tight" data-id="element-795">
                      $10K–$20K/mes
                    </div>
                  </div>
                </div>
              </div>

              <div className="hidden md:flex absolute bottom-4 right-0 lg:-right-6 z-20 bg-[#0f1b35] border border-amber-500/30 rounded-2xl px-4 py-3 shadow-2xl" data-id="element-796">
                <div className="flex items-center gap-2.5" data-id="element-797">
                  <div className="w-9 h-9 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-798">
                    <FileText className="w-4 h-4 text-amber-400" data-id="element-799" />
                  </div>
                  <div className="text-left" data-id="element-800">
                    <div className="text-[10px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-801">
                      Contenido
                    </div>
                    <div className="text-sm font-black text-white leading-tight" data-id="element-802">
                      30+ páginas
                    </div>
                  </div>
                </div>
              </div>

              {/* Glow halo */}
              <div className="absolute inset-0 bg-amber-400/25 blur-[120px] rounded-full scale-90 pointer-events-none" data-id="element-803" />

              <img src="https://cdn.magicpatterns.com/uploads/b6UJiQY8AShyrqdN6JMwxG/private_openrouter-generated-image-1778779593292.png" alt="Escapa del Dealership — Guía Gratuita para vendedores hispanos en USA" className="relative w-full h-auto drop-shadow-[0_30px_60px_rgba(245,158,11,0.35)] hover:scale-[1.02] transition-transform duration-500" data-id="element-804" />
            </div>

            {/* Mobile-only badges — stacked below image so they don't overlap */}
            <div className="flex md:hidden items-stretch justify-center gap-2.5 mt-5 w-full px-2" data-id="element-805">
              <div className="flex-1 flex items-center gap-2 bg-[#0f1b35] border border-amber-500/30 rounded-xl px-3 py-2.5 shadow-xl" data-id="element-806">
                <div className="w-8 h-8 rounded-lg bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center flex-shrink-0" data-id="element-807">
                  <TrendingUp className="w-4 h-4 text-emerald-400" data-id="element-808" />
                </div>
                <div className="text-left min-w-0" data-id="element-809">
                  <div className="text-[9px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-810">
                    Ingreso meta
                  </div>
                  <div className="text-[12px] font-black text-white leading-tight truncate" data-id="element-811">
                    $10K–$20K/mes
                  </div>
                </div>
              </div>

              <div className="flex-1 flex items-center gap-2 bg-[#0f1b35] border border-amber-500/30 rounded-xl px-3 py-2.5 shadow-xl" data-id="element-812">
                <div className="w-8 h-8 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-813">
                  <FileText className="w-4 h-4 text-amber-400" data-id="element-814" />
                </div>
                <div className="text-left min-w-0" data-id="element-815">
                  <div className="text-[9px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-816">
                    Contenido
                  </div>
                  <div className="text-[12px] font-black text-white leading-tight truncate" data-id="element-817">
                    30+ páginas
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile-only primary CTA — sits directly under the image */}
            <div className="md:hidden mt-5 px-2" data-id="element-818">
              <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base uppercase tracking-tight rounded-2xl py-5 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 overflow-hidden" data-id="element-819">
                <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-820">
                  <Download className="w-5 h-5" data-id="element-821" />
                  DESCARGAR LA GUÍA GRATIS
                  <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-822" />
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-823" />
              </button>
            </div>
          </div>

          {/* Benefits */}
          <ul className="space-y-2.5 mb-8 md:mb-10 max-w-xl mx-auto text-left" data-id="element-824">
            {benefits.map(b => <li key={b.text} className="flex items-center gap-3" data-id="element-825">
                <div className="w-7 h-7 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center flex-shrink-0" data-id="element-826">
                  <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-827" />
                </div>
                <span className="text-sm md:text-base text-gray-200 font-medium leading-snug" data-id="element-828">
                  {b.text}
                </span>
              </li>)}
          </ul>

          {/* Primary CTA — hidden on mobile (shown above under image) */}
          <div className="max-w-md mx-auto" data-id="element-829">
            <button type="button" onClick={() => setShowModal(true)} className="hidden md:block group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-830">
              <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-831">
                <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-832" />
                DESCARGAR LA GUÍA GRATIS
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-833" />
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-834" />
            </button>

            {/* Polished trust microcopy — pill chip layout */}
            <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-835">
              {['100% gratis', 'Descarga inmediata', 'Sin tarjeta de crédito', '30+ páginas aplicables'].map(item => <div key={item} className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.06] rounded-full px-3 py-1.5" data-id="element-836">
                  <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" data-id="element-837" />
                  <span className="text-[11px] md:text-xs text-gray-400 font-medium truncate" data-id="element-838">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ PROBLEM / TRANSFORMATION ============ */}
        <section className="mb-16 md:mb-24" data-id="element-839">
          <div className="text-center mb-10 md:mb-12" data-id="element-840">
            <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-841">
              La Realidad
            </div>
            <h2 className="text-2xl md:text-4xl font-black leading-tight max-w-3xl mx-auto" data-id="element-842">
              De atrapado en el dealership a{' '}
              <span className="text-amber-400" data-id="element-843">dueño de tu tiempo</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto" data-id="element-844">
            {/* Before */}
            <div className="relative bg-gradient-to-br from-red-950/30 to-[#0a1428] border border-red-500/20 rounded-2xl p-6 md:p-8" data-id="element-845">
              <div className="flex items-center gap-2.5 mb-5" data-id="element-846">
                <div className="w-9 h-9 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center" data-id="element-847">
                  <XCircle className="w-4 h-4 text-red-400" data-id="element-848" />
                </div>
                <span className="text-red-400 text-xs font-black uppercase tracking-widest" data-id="element-849">
                  Antes
                </span>
              </div>
              <ul className="space-y-3 text-gray-300 text-sm md:text-base" data-id="element-850">
                {['12+ horas en el showroom esperando walk-ins', 'Comisiones cortadas por el gerente', 'Cuotas mensuales que dictan tu vida', 'Sin control sobre tu calendario o ingresos'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-851">
                    <X className="w-4 h-4 text-red-400 flex-shrink-0 mt-1" data-id="element-852" />
                    <span className="leading-snug" data-id="element-853">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="relative bg-gradient-to-br from-amber-950/30 to-[#0a1428] border border-amber-500/30 rounded-2xl p-6 md:p-8 shadow-[0_0_40px_rgba(245,158,11,0.12)]" data-id="element-854">
              <div className="flex items-center gap-2.5 mb-5" data-id="element-855">
                <div className="w-9 h-9 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center" data-id="element-856">
                  <Sparkles className="w-4 h-4 text-amber-400" data-id="element-857" />
                </div>
                <span className="text-amber-400 text-xs font-black uppercase tracking-widest" data-id="element-858">
                  Después
                </span>
              </div>
              <ul className="space-y-3 text-gray-200 text-sm md:text-base" data-id="element-859">
                {['Cierras desde tu casa, a tu ritmo', '100% del valor que generas va a ti', 'Sin cuotas — sin gerente encima', 'Calendario, ingresos y crecimiento bajo tu control'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-860">
                    <CheckCircle2 className="w-4 h-4 text-amber-400 flex-shrink-0 mt-1" data-id="element-861" />
                    <span className="leading-snug" data-id="element-862">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* ============ WHAT'S INSIDE ============ */}
        <section className="mb-16 md:mb-24" data-id="element-863">
          <div className="text-center mb-10 md:mb-14" data-id="element-864">
            <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-865">
              Lo Que Vas A Descubrir
            </div>
            <h2 className="text-2xl md:text-4xl font-black leading-tight max-w-3xl mx-auto" data-id="element-866">
              Qué hay <span className="text-amber-400" data-id="element-867">dentro</span> de la guía
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto" data-id="element-868">
            {insideGuide.map(item => <div key={item.number} className="group relative bg-white/[0.025] border border-white/[0.08] rounded-2xl p-6 md:p-7 hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-869">
                <div className="absolute top-6 right-6 text-4xl md:text-5xl font-black text-amber-400/15 group-hover:text-amber-400/30 transition-colors" data-id="element-870">
                  {item.number}
                </div>
                <h3 className="relative text-base md:text-lg font-black text-white mb-2 pr-12 leading-snug" data-id="element-871">
                  {item.title}
                </h3>
                <p className="text-sm md:text-[15px] text-gray-400 leading-relaxed" data-id="element-872">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </section>

        {/* ============ FINAL CTA ============ */}
        <section className="mb-8" data-id="element-873">
          <div className="relative max-w-3xl mx-auto" data-id="element-874">
            {/* Glow */}
            <div className="absolute -inset-2 bg-amber-400/20 blur-3xl rounded-3xl pointer-events-none" data-id="element-875" />

            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-8 md:p-12 text-center shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-876">
              {/* Corner accent */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-amber-400/10 blur-3xl rounded-full" data-id="element-877" />

              <div className="relative" data-id="element-878">
                <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-879">
                  <Clock className="w-3.5 h-3.5 text-amber-400" data-id="element-880" />
                  <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-widest" data-id="element-881">
                    Acceso Inmediato
                  </span>
                </div>

                <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-4 max-w-xl mx-auto" data-id="element-882">
                  Listo para dar el{' '}
                  <span className="text-amber-400" data-id="element-883">primer paso</span> fuera del
                  dealership?
                </h2>

                <p className="text-gray-300 text-base md:text-lg mb-7 max-w-lg mx-auto leading-relaxed" data-id="element-884">
                  Descarga la guía y empieza a ver tu carrera con otros ojos —
                  hoy mismo.
                </p>

                <button type="button" onClick={() => setShowModal(true)} className="group relative w-full max-w-md mx-auto bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex" data-id="element-885">
                  <span className="relative z-10 flex items-center justify-center gap-2.5 w-full" data-id="element-886">
                    <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-887" />
                    DESCARGAR LA GUÍA GRATIS
                    <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-888" />
                  </span>
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-889" />
                </button>

                <div className="mt-5 flex items-center justify-center gap-x-5 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-890">
                  <span className="flex items-center gap-1.5" data-id="element-891">
                    <Lock className="w-3.5 h-3.5 text-emerald-400" data-id="element-892" />
                    100% seguro
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-893">
                    <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" data-id="element-894" />
                    Sin spam
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-895">
                    <Download className="w-3.5 h-3.5 text-emerald-400" data-id="element-896" />
                    Descarga al instante
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-897" />

      {/* Social proof download notification */}
      <DownloadNotification data-id="element-898" />

      {/* Lead Capture Modal */}
      {showModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in" onClick={() => setShowModal(false)} data-id="element-899">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)]" onClick={e => e.stopPropagation()} data-id="element-900">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-901">
              <X className="w-6 h-6" data-id="element-902" />
            </button>

            <div className="text-center mb-6" data-id="element-903">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-904">
                <Download className="w-6 h-6 text-amber-400" data-id="element-905" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-906">
                Descarga Tu Guía
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-907">
                Ingresa tus datos para recibir acceso inmediato
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-908">
              <div className="space-y-1" data-id="element-909">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-910">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-911">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-912">
                    <User className="h-5 w-5 text-gray-500" data-id="element-913" />
                  </div>
                  <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-914" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-915">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-916">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-917">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-918">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-919" />
                  </div>
                  <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-920" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-921">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-922">
                  WhatsApp / Teléfono
                </label>
                <div className="flex gap-2" data-id="element-923">
                  <div className="relative w-1/3" data-id="element-924">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-925">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-926" />
                    </div>
                    <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-927">
                      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-928">
                          {c.code} {c.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-929">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-930">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-931" />
                    </div>
                    <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-932" />
                  </div>
                </div>
              </div>

              <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden" data-id="element-933">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-934">
                  {isSubmitting ? <>Enviando...</> : <>
                      <Download className="w-5 h-5" data-id="element-935" />
                      DESCARGAR AHORA
                      <ArrowRight className="w-5 h-5" data-id="element-936" />
                    </>}
                </span>
              </button>

              <div className="flex items-center justify-center gap-1.5 text-xs text-gray-500" data-id="element-937">
                <Lock className="w-3 h-3" data-id="element-938" />
                Tu información está 100% segura
              </div>
            </form>
          </div>
        </div>}
    </div>;
}